// tslint:disable: directive-selector
import { Directive, Input, ElementRef, Renderer, OnInit } from "@angular/core";
import { IConnVisibilityCategory, TCIConnectionVisibility } from "@tci/common";

@Directive({
    selector: "[NgVisibilityIcon]"
})
export class NgVisibilityIconDirective implements OnInit {
    @Input() NgVisibilityIcon: IConnVisibilityCategory;

    constructor(private el: ElementRef, private renderer: Renderer) {
    }

    ngOnInit() {
        const category = TCIConnectionVisibility.fromId(this.NgVisibilityIcon.id);
        if (category) {
            const icContainer = this.renderer.createElement(this.el.nativeElement, "div");
            this.renderer.setElementClass(icContainer, "ng-ic-category", true);

            const icUrl = `url(../../assets/img/${category.iconUrl})`;
            this.renderer.setElementStyle(icContainer, "-webkit-mask-image", icUrl);
            this.renderer.setElementStyle(icContainer, "mask-image", icUrl);
        }
    }
}
